<style>
.overflow-hidden {
  overflow: hidden;
}
.horiz-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}
</style>

<template>
<!-- class='horiz-scroll' -->
<v-layout wrap row >
  <v-flex v-for='col in cols' :key='col.value' xs12 sm4 >
    <v-toolbar dense flat  >
      <v-btn @click='toggleCol(col)'
        icon class='visible-xs-only' >
        <v-icon v-if='visible[col.value]' small >expand_less</v-icon>
        <v-icon v-else small >expand_more</v-icon>
      </v-btn>
      <v-subheader class='subheading' >{{col.text}} days</v-subheader>
      <v-spacer></v-spacer>
      <span class='mr-4' >{{ formatCurrency('ZAR', totals[col.value]) }}</span>
    </v-toolbar>
    <invoice-list
      v-if='visible[col.value]'
      class='invoice-list'
      :class='col.color'
      :invoices='report[col.value]'
      :actions="actions"
      :loading="request.loading"
      v-on='events'
      :primary-action="{icon: 'chevron_right', text: 'More'}" >
    </invoice-list>
    </slot>
  </v-flex>
</v-layout>
</template>

<script>
import Vue from 'vue'
import InvoiceList from '@/components/invoice/InvoiceList'
import Kanban from '@/components/invoice/layout/Kanban'

export default {
  name: 'OverdueKanban',
  components: {InvoiceList, Kanban},
  props: {
    data: { type: Array, default: () => { return {} } },
    actions: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      reqId: 'invoices-overdue-request',
      visible: {},
      cols: [
        {text: '0-30', value: 'thirty', color: ''},
        {text: '30-60', value: 'sixty', color: 'amber lighten-4'},
        {text: '90', value: 'ninety', color: 'red lighten-4'}
      ]
    }
  },
  mounted () {
    this.fetchOverdue()
    this.cols.forEach(col => {
      Vue.set(this.visible, col.value, true)
    })
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    report () {
      let response = this.getObjectPath(this.request, 'result.data', false)
      if (response === false) {
        return {
          'thirty': [], 'sixty': [], 'ninety': []
        }
      }
      return response
    },
    totals () {
      return {
        'thirty': this.report['thirty'].reduce((total, item) => { return parseFloat(item.invoice_amount) + total }, 0),
        'sixty': this.report['sixty'].reduce((total, item) => { return parseFloat(item.invoice_amount) + total }, 0),
        'ninety': this.report['ninety'].reduce((total, item) => { return parseFloat(item.invoice_amount) + total }, 0)
      }
    },
    events () {
      let vm = this
      let events = {
        'primarycta': (invoice) => { vm.$emit('primarycta', invoice) }
      }
      this.actions.forEach((action) => {
        events[action.action] = (invoice) => {
          vm.$emit(action.action, invoice)
        }
      })
      return events
    }
  },
  methods: {
    fetchOverdue () {
      return this.$invoiceguru.resource('overdue').id(this.reqId).list()
    },
    toggleCol (col) {
      Vue.set(this.visible, col.value, !this.visible[col.value])
    }
  }
}
</script>



// WEBPACK FOOTER //
// OverdueKanban.vue?4eddb146